import { PiCheckCircleDuotone } from 'react-icons/pi';
import { FcApproval } from 'react-icons/fc';

import Node, { Button } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';

import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

export default function ApproveNode(props) {
    const { optimizationPipelineDetail, optimizationPipelineDetailsLoading, optimizationPipelineDetailsLoaded, openPopup } = useOptimizationPipeline();

    return (
        <Node ref={props.anchorRef} title='Approve' icon={PiCheckCircleDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>

            <div className='w-full flex flex-col gap-8'>

                <div className='w-full flex flex-col gap-10'>

                    <Button genericType='DETAILS' onClick={() => { openPopup({ type: 'DYNAMIC_VALIDATION_DETAILS' }); }} />
                    <Button label='Approve' className='hover:bg-green-50' icon={FcApproval} onClick={() => { openPopup({ type: 'APPROVE_SETTINGS' }); }} />

                </div>

            </div>

        </Node>
    );
}